module.exports = __webpack_public_path__ + "static/media/residencialIcon.0d60ba2c.svg";